import { getDataMapper, mapField, mapArray } from "@/shared";
export const mapExpenseTypeFromServer = getDataMapper({
    id: mapField("id", Number),
    title: mapField("title"),
});

export const mapExpenseTypesFromServer = mapArray(mapExpenseTypeFromServer);
